import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import CustomersCrmStatisticsAPI from '../../../api/CustomersCrmStatisticsAPI';

type Props = { timeRange: { start: string; end: string } };

function ConversionRateCard({ timeRange }: Props) {
  const { t } = useTranslation();
  const [rate, setRate] = useState<number | null>(null);
  const [uniqueCustomers, setUniqueCustomers] = useState(0);
  const [withSale, setWithSale] = useState(0);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await CustomersCrmStatisticsAPI.getConversionRate({ startTime: timeRange.start, endTime: timeRange.end });
        const data = res.data;
        if (data) {
          setUniqueCustomers(data.uniqueCustomers);
          setWithSale(data.uniqueCustomersWithSale);
          setRate(data.conversionRatePercent);
        } else {
          setRate(0);
          setUniqueCustomers(0);
          setWithSale(0);
        }
      } catch {
        setRate(0);
        setUniqueCustomers(0);
        setWithSale(0);
      }
    };
    fetchData();
  }, [timeRange.start, timeRange.end]);

  const displayRate = rate !== null ? `${Number(rate).toFixed(1)}%` : '—';

  return (
    <div className="space-y-1">
      <p className="text-2xl font-bold text-foreground">{displayRate}</p>
      <p className="text-sm text-muted-foreground">
        {t('stats.conversion_rate') || 'Conversion rate'}
      </p>
      {(uniqueCustomers > 0 || withSale > 0) && (
        <p className="text-xs text-muted-foreground">
          {t('stats.conversion_rate.breakdown', { withSale, uniqueCustomers })}
        </p>
      )}
    </div>
  );
}

export default ConversionRateCard;
